import React from 'react';
import { useRecoilValue } from 'recoil';
import { IBlock } from '../../../../utils/types/contentful';
import { withWindowScroll } from '../../../../utils/hocs/withWindowScroll';
import { SubHeaderState } from '../../../../utils/recoil/subHeader';
import { subHeaderScrollTrigger } from '../../../../utils/globals/index';

interface SubHeaderProps {
  reassurances: IBlock;
  subHeader: Element;
}

export const SubHeader = withWindowScroll(({ scroll }: SubHeaderProps) => {
  const subHeader = useRecoilValue(SubHeaderState);
  const isScrollTriggerReached = scroll >= subHeaderScrollTrigger;
  const isSubHeaderActive = isScrollTriggerReached || subHeader.isDefaultScroll;
  const styleTopBottom = subHeader.placement === 'top' ? 'top-0' : 'bottom-0';
  const translateStyle =
    isSubHeaderActive &&
    `${
      subHeader.placement === 'top' ? 'translate-y-16' : 'translate-y-0'
    } pointer-events-auto opacity-100`;

  return (
    <div
      className={`w-full border-b fixed ${styleTopBottom} opacity-0 pointer-events-none ${translateStyle}  transform flex flex-col justify-center items-center bg-white transition duration-300 ease-out text-sm z-10`}>
      {subHeader.children}
    </div>
  );
});
